import { WalletConnectConnector } from '@web3-react/walletconnect-connector';

const walletConnect = new WalletConnectConnector({
  qrcode: true,
});

export default walletConnect;
